import styled from 'styled-components/native';

import { moderateScale } from '../../../../../utils/scaleHelpers';
import { BorderlessButton, LargePrimaryButton } from '../../../../base_ui';

export const ClearButton = styled(BorderlessButton).attrs(({
  theme: { colors: { linkText }, fontFamilies: { secondaryFont } },
  titleStyle,
}) => ({ titleStyle: [titleStyle, { color: linkText, fontFamily: secondaryFont }] }))`
  margin: ${moderateScale(10)}px 0 ${moderateScale(35)}px;
  padding: 0 ${moderateScale(14)}px;
`;

export const FormContainer = styled.View`
  align-items: center;
  flex: auto;
  margin-top: ${moderateScale(24)}px;
`;

export const StyledLargePrimaryButton = styled(LargePrimaryButton)`
  align-self: center;
  margin: ${moderateScale(19)}px 0 ${moderateScale(35)}px;
`;

export const UseExistingContainer = styled.View`
  align-items: center;
  padding-bottom: ${moderateScale(26)}px;
`;
